module.exports = __webpack_public_path__ + "media/entities/6002-dc4a6cd4.png";